import { MaterialType } from '../../../backend/src/types.generated';

export const materialTypeFormat: Record<MaterialType, { emoji: string; label: string }> = {
	[MaterialType.Textiles]: { emoji: '🧵', label: 'Textiles' },
	[MaterialType.LiquidPaperBoard]: { emoji: '💧', label: 'Liquid Paper Board' },
	[MaterialType.BlendedFibre]: { emoji: '🧶', label: 'Blended Fibre' },
	[MaterialType.Cardboard]: { emoji: '📦', label: 'Cardboard' },
	[MaterialType.MixedPlastic]: { emoji: '♻️', label: 'Mixed Plastic' },
	[MaterialType.SoftPlastic]: { emoji: '🛍️', label: 'Soft Plastic' },
	[MaterialType.CoffeePods]: { emoji: '☕', label: 'Coffee Pods' },
	[MaterialType.MixedPaper]: { emoji: '📰', label: 'Mixed Paper' },
	[MaterialType.GlassCoarse]: { emoji: '👓', label: 'Glass (Coarse)' },
	[MaterialType.GlassMedium]: { emoji: '🕶️', label: 'Glass (Medium)' },
	[MaterialType.GlassFine]: { emoji: '🥽', label: 'Glass (Fine)' },
	[MaterialType.GlassSuperfine]: { emoji: '🔭', label: 'Glass (Superfine)' },
	[MaterialType.GlassMoondust]: { emoji: '🌙', label: 'Glass (Moondust)' },
	[MaterialType.GlassSf_500_300]: { emoji: '🥃', label: 'Glass (SF-500/300)' },
	[MaterialType.GlassSf_300_150]: { emoji: '🍷', label: 'Glass (SF-300/150)' },
};
